/* Twenty25 theme scripts */
(function () {
  'use strict';

  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    btn.addEventListener('click', function () { setOpen(!nav.classList.contains('is-open')); });
    // Close with Escape, after choosing a link, or when the screen gets wide
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) { setOpen(false); btn.focus(); }
    });
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    window.addEventListener('resize', function () { if (window.innerWidth > 900) setOpen(false); });
  });

  // Hero slideshow: slides to the left on a timer, loops seamlessly
  document.querySelectorAll('[data-hero-slider]').forEach(function (hero) {
    var track = hero.querySelector('[data-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-slide]');
    var count = slides.length;
    if (count < 2) return;
    var dots = hero.querySelectorAll('[data-dot]');
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Clone the first slide onto the end so the loop always moves left
    var clone = slides[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);

    var index = 0;
    var timer = null;

    function setDots(i) {
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    function goTo(i, animate) {
      if (animate) track.classList.add('is-animating'); else track.classList.remove('is-animating');
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      index = i;
      setDots(i % count);
    }
    track.addEventListener('transitionend', function () {
      if (index === count) { goTo(0, false); }
    });
    function next() { goTo(index + 1, true); }
    function start() { if (!reduce && !timer) timer = setInterval(next, interval); }
    function stop() { clearInterval(timer); timer = null; }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        stop();
        goTo(parseInt(d.getAttribute('data-dot'), 10), true);
        start();
      });
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  });

  // Review form pop-up
  document.querySelectorAll('[data-review-open]').forEach(function (btn) {
    var dialog = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dialog || typeof dialog.showModal !== 'function') return;
    btn.addEventListener('click', function () { dialog.showModal(); });
    dialog.querySelectorAll('[data-review-close]').forEach(function (c) {
      c.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    // (Re-opening after a review is sent is handled by the form confirmation code below)
  });

  // Contact & review forms.
  // Shopify's built-in spam check sends these forms the normal way (the page reloads),
  // so we remember which form was sent and confirm clearly when the page comes back.
  var SENT_KEY = 't25-form-sent';
  function store(key, val) { try { if (val === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
  function read(key) { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; } }

  function contactForms() {
    return Array.prototype.filter.call(document.querySelectorAll('form'), function (f) {
      var t = f.querySelector('input[name="form_type"]');
      return t && t.value === 'contact';
    });
  }

  function showToast(text) {
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = '<span class="toast__icon" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span><span class="toast__text"></span><button type="button" class="toast__close" aria-label="Close">&times;</button>';
    toast.querySelector('.toast__text').textContent = text;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    function hide() { toast.classList.remove('is-visible'); setTimeout(function () { toast.remove(); }, 400); }
    toast.querySelector('.toast__close').addEventListener('click', hide);
    setTimeout(hide, 7000);
  }

  function showSuccess(form) {
    var fields = form.querySelector('[data-form-fields]');
    var stat = form.querySelector('[data-form-success-static]');
    var dyn = form.querySelector('[data-form-success]');
    var success = dyn || stat;
    // Show one confirmation box in place of the form
    if (dyn && fields) { fields.hidden = true; dyn.hidden = false; if (stat) stat.hidden = true; }
    var dialog = form.closest('dialog');
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    if (success) {
      setTimeout(function () {
        if (!dialog) success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (success.focus) success.focus({ preventScroll: true });
      }, 80);
    }
  }

  contactForms().forEach(function (form) {
    var submit = form.querySelector('[data-form-submit]');
    // Remember the send, and show that it's working. We don't stop the normal send.
    form.addEventListener('submit', function () {
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
      store(SENT_KEY, { id: form.id, path: window.location.pathname, t: Date.now() });
      if (submit) { submit.textContent = 'Sending…'; submit.setAttribute('aria-busy', 'true'); }
    }, true);

    form.querySelectorAll('[data-form-again]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fields = form.querySelector('[data-form-fields]');
        var success = form.querySelector('[data-form-success]');
        var stat = form.querySelector('[data-form-success-static]');
        if (success) success.hidden = true;
        if (stat) stat.hidden = true;
        if (fields) { fields.hidden = false; var first = fields.querySelector('input:not([type="hidden"]), select, textarea'); if (first) first.focus(); }
      });
    });
  });

  // When the page loads after a send, confirm it
  (function () {
    var sent = read(SENT_KEY);
    var params = new URLSearchParams(window.location.search);
    var posted = params.get('contact_posted') === 'true';
    var hashId = (window.location.hash || '').replace('#', '');
    var recent = sent && (Date.now() - sent.t) < 10 * 60 * 1000;
    if (!posted && !recent) return;

    // A problem with the form (Shopify shows the error in the form): leave it showing
    var errorShown = contactForms().some(function (f) { return f.querySelector('.notice[role="alert"]:not([hidden])'); });
    if (errorShown && !posted) { store(SENT_KEY, null); return; }
    if (!posted) return; // not back from the send yet (e.g. on the spam-check page)

    var formId = (recent && sent.id) || hashId;
    // If Shopify brought them back to a different page (e.g. the homepage), return them to where they were
    if (recent && sent.path && sent.path !== window.location.pathname) {
      window.location.replace(sent.path + '?contact_posted=true#' + (sent.id || ''));
      return;
    }
    store(SENT_KEY, null);
    var form = (formId && document.getElementById(formId)) || contactForms()[0];
    var isReview = form && form.id === 'ReviewForm';
    if (form) showSuccess(form);
    // Reviews confirm inside the review window; everything else gets the pop-up at the top too
    var inDialog = form && form.closest('dialog');
    if (!inDialog) showToast(isReview ? 'Thanks! Your review has been sent.' : "Message sent! We'll get back to you soon.");
  })();

  // Sticky header: add a shadow once the page has scrolled
  document.querySelectorAll('.site-header--sticky').forEach(function (header) {
    var ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  });

  // Sort select: go to sorted URL on change
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-step'), 10);
        var min = parseInt(input.getAttribute('min') || '0', 10);
        var v = Math.max(min, (parseInt(input.value, 10) || 0) + step);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product page: thumbnails + variant pills
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var mainImg = root.querySelector('img.product__main-img');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = t.getAttribute('data-src');
        mainImg.srcset = '';
        root.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    var json = root.querySelector('[data-variants]');
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    var addLabel = addBtn ? addBtn.getAttribute('data-label') : '';
    var money = root.getAttribute('data-money') || '£{{amount}}';

    function format(cents) {
      var amount = (cents / 100).toFixed(2);
      return money.replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }

    function update() {
      var chosen = [];
      root.querySelectorAll('[data-option-group]').forEach(function (g) {
        var c = g.querySelector('input:checked');
        chosen.push(c ? c.value : null);
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = format(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addLabel : 'Sold out';
      }
      if (match.image && mainImg) { mainImg.src = match.image; mainImg.srcset = ''; }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-option-group] input').forEach(function (i) {
      i.addEventListener('change', update);
    });
  });

  // Product page: make sure a scent is picked before adding to basket
  document.querySelectorAll('.scent-group').forEach(function (group) {
    var form = group.closest('form');
    var hint = group.querySelector('[data-scent-hint]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (group.querySelector('input:checked')) return;
      e.preventDefault();
      group.classList.add('is-missing');
      if (hint) hint.hidden = false;
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = group.querySelector('input');
      if (first) first.focus({ preventScroll: true });
    });
    // If the browser's own "please select" check fires first, show our message too
    group.querySelectorAll('input').forEach(function (i) {
      i.addEventListener('invalid', function () {
        group.classList.add('is-missing');
        if (hint) hint.hidden = false;
      });
    });
    group.addEventListener('change', function () {
      group.classList.remove('is-missing');
      if (hint) hint.hidden = true;
    });
  });

  // Cart: auto-submit when a quantity changes
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    var timer;
    form.querySelectorAll('input[name="updates[]"]').forEach(function (i) {
      i.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { form.submit(); }, 400);
      });
    });
  });
})();
